module.exports = __webpack_public_path__ + "static/media/Tomato.5cada894.png";